import { FC, useMemo } from 'react';
import { Badge, Box } from '@robocorp/components';
import { IconType } from '@robocorp/icons';
import { IconDoubleChevronDown, IconDoubleChevronUp } from '@robocorp/icons/iconic';

type Props = {
  label: string;
  value: number;
};

/**
 * Values helper component to display a metrics value ticker like Badge
 *
 * @example
 * <Values.Ticker label="Label" onClick={onClick}>Value</Values.Item>
 */
export const Ticker: FC<Props> = ({ value, label }) => {
  const props = useMemo(() => {
    if (value < 0) {
      return {
        icon: IconDoubleChevronDown as IconType,
        variant: 'danger' as const,
      };
    }
    return {
      icon: IconDoubleChevronUp as IconType,
      variant: 'success' as const,
    };
  }, [value]);

  if (value === 0) {
    return null;
  }

  return (
    <Box as="span" mx="$8">
      <Badge label={label} {...props} />
    </Box>
  );
};
